<template>
  <div>
    <iframe
      :src="content"
      style="width: 100%;height: 96vh;border:none;padding: 0;margin: 0"
    ></iframe>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getDevOpsSpaceUserDepartmentInfoApi } from "@/server/tops/devOps";
export default {
  data() {
    return {
      content: "",
      department: "",
      departmentMap: {
        前端开发部: "700286116",
        JAVA开发组: "700286120",
        数字技术管理部: "700102083",
        测试管理部: "700286123",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.devOps.userInfo,
    }),
  },
  async created() {
    let url = this.$route.path;
    await this.getWorkOrderUserDepartment();

    let userId = this.userInfo.userId;
    let deptId = "";
    if (process.env.NODE_ENV === "production") {
      deptId = this.departmentMap[this.department] || "";
    } else if (process.env.NODE_ENV === "development") {
      userId = "613";
      deptId = "3848157";
    }

    console.log(JSON.parse(localStorage.getItem(url)));
    let content = JSON.parse(localStorage.getItem(url));

    content += `?userId=${userId}`;
    if (deptId) {
      content += `&deptId=${deptId}`;
    }
    this.content = content;
  },
  methods: {
    async getWorkOrderUserDepartment(userId = "") {
      if (!userId) {
        userId = this.$store.state.devOps.userInfo.userId;
      }
      await getDevOpsSpaceUserDepartmentInfoApi({ user_id: userId }).then(
        (res) => {
          if (res?.data?.dept_name) {
            this.department = res.data?.dept_name.split("/").pop();
          }
        }
      );
    },
  },
};
</script>
